// @flow

import React, { PureComponent, Fragment } from 'react';
import { Link } from 'react-router-dom';

import { handleTagEvent } from 'utils/tagManagerUtils';
import { ffrName } from 'utils/ffrNameUtils';
/**
 * $FlowFixMe
 * Original lib -> https://github.com/nwcell/ics.js
 * But ... no package and module export
 * "Open source" 😒
 */
import ics from 'libs/ics';

import { getDateFromString, formatFullDateString } from 'utils/dateUtils';

import Loading from 'components/fragments/Loading';
import DropdownRadioInput from 'components/fragments/input/DropdownRadioInput';
import type { Status } from 'types/Status';
import type { CompetitionRankingType, RankingType } from 'types/Ranking';
import type { CompetitionResultType, JourneeResultType, ResultType } from 'types/Result';
import type { RouterProps } from 'types/Router';
import type { ResultCalendarContainerType } from 'types/Result';

import { STATUS_LOADING } from 'constants/statusConstants';

export type StateProps = {
  ranking: CompetitionRankingType[],
  competitions: CompetitionResultType[],
  calendarStatus: Status,
  resultStatus: Status,
  nextMatches: ResultCalendarContainerType,
  clubNom: string
};

type Props = StateProps & RouterProps;

type State = {
  rankingDropdownSelection: string
};

export default class ResultAndRanking extends PureComponent<Props, State> {
  icsGenerator = ics();

  state = {
    rankingDropdownSelection: ''
  };

  renderRencontres = (rencontres: ResultType[]): React$Node[] => {
    const {
      match: {
        params: { slug }
      }
    } = this.props;

    return (
      rencontres &&
      rencontres.map(
        ({
          id,
          localStructure: { nom: localNom, embleme: localEmbleme, id: localId },
          visiteurStructure: { nom: visiteurNom, embleme: visiteurEmbleme, id: visiteurId },
          resultLocal: { pointsDeMarque: pointLocal },
          resultVisiteur: { pointsDeMarque: pointVisiteur }
        }) => {
          const classNameWin = 'ft-700';
          const localWin = pointVisiteur < pointLocal;
          const visitorWin = pointVisiteur > pointLocal;
          const title = `Voir les informations du match ${localNom}-${visiteurNom}`;

          return (
            <Fragment key={id}>
              {slug && (
                <Link to={`/equipes/${slug}/match/${id}`} className="match" title={title}>
                  <div className="match__club">
                    <p title={localNom} className={(localWin && classNameWin) || ''}>
                      <span>{ffrName(localNom)}</span>
                      <img src={localEmbleme} alt={`Logo ${localNom}`} width="24" height="24" />
                    </p>
                  </div>
                  <div className="match__info">
                    <p className="match__score">
                      <span className={(localWin && classNameWin) || ''}>{pointLocal}</span>
                      <span className="match__colon">-</span>
                      <span className={(visitorWin && classNameWin) || ''}>{pointVisiteur}</span>
                    </p>
                  </div>
                  <div className="match__club">
                    <p title={visiteurNom} className={(visitorWin && classNameWin) || ''}>
                      <img src={visiteurEmbleme} alt={`Logo ${visiteurNom}`} width="24" height="24" />
                      <span>{ffrName(visiteurNom)}</span>
                    </p>
                  </div>
                </Link>
              )}
            </Fragment>
          );
        }
      )
    );
  };

  renderRencontre = (rencontre: ResultType): React$Node => {
    const {
      match: {
        params: { slug }
      }
    } = this.props;

    const {
      id,
      localStructure: { nom: localNom, embleme: localEmbleme },
      visiteurStructure: { nom: visiteurNom, embleme: visiteurEmbleme },
      resultLocal: { pointsDeMarque: pointLocal },
      resultVisiteur: { pointsDeMarque: pointVisiteur }
    } = rencontre;

    const classNameWin = 'ft-700';
    const localWin = pointVisiteur < pointLocal;
    const visitorWin = pointVisiteur > pointLocal;
    const title = `Voir les informations du match ${localNom}-${visiteurNom}`;

    return (
      <Fragment key={id}>
        {slug && (
          <Link to={`/equipes/${slug}/match/${id}`} className="match" title={title}>
            <div className="match__club">
              <p title={localNom} className={(localWin && classNameWin) || ''}>
                <span>{ffrName(localNom)}</span>
                <img src={localEmbleme} alt={`Logo ${localNom}`} width="24" height="24" />
              </p>
            </div>
            <div className="match__info">
              <p className="match__score">
                <span className={(localWin && classNameWin) || ''}>{pointLocal}</span>
                <span className="match__colon">-</span>
                <span className={(visitorWin && classNameWin) || ''}>{pointVisiteur}</span>
              </p>
            </div>
            <div className="match__club">
              <p title={visiteurNom} className={(visitorWin && classNameWin) || ''}>
                <img src={visiteurEmbleme} alt={`Logo ${visiteurNom}`} width="24" height="24" />
                <span>{ffrName(visiteurNom)}</span>
              </p>
            </div>
          </Link>
        )}
      </Fragment>
    );
  };

  renderCompDayRow = (journees: JourneeResultType[]): React$Node[] => {
    return (
      journees &&
      journees
        .slice(-3)
        .reverse()
        .map(({ id, nom, date, rencontres }) => {
          return (
            <Fragment key={id}>
              <p className="ft-h6 ft-up ft-center">
                {nom} — {formatFullDateString(date)}
              </p>
              {this.renderRencontres(rencontres)}
            </Fragment>
          );
        })
    );
  };

  renderLastResults = () => {
    const {
      competitions,
      resultStatus,
      match: {
        params: { slug }
      }
    } = this.props;

    const journeesFinales = [];
    let rencontresFinales = [];
    competitions.map(({ id, nom, journees }) => {
      journees
        .slice(-3)
        .reverse()
        .map(journee => {
          journeesFinales.push(journee);
          journee.rencontres.map(rencontre => {
            rencontresFinales.push(rencontre);
            return null;
          });
          return null;
        });
      return null;
    });
    rencontresFinales = rencontresFinales
      .sort((a, b) => a.dateEffective.getTime() - b.dateEffective.getTime())
      .slice(-3)
      .reverse();

    let competitionEnCours = '';
    let journeeEnCours = '';
    return (
      <div className="col col-md-4 mb-2 mb-lg-4">
        <div className="box box--white card card--result">
          <div className="card__body">
            <h3 className="mb-2">Derniers résultats</h3>
            {resultStatus === STATUS_LOADING && <Loading />}
            {resultStatus !== STATUS_LOADING && rencontresFinales.length === 0 && (
              <Fragment>
                <div className="placeholder">
                  <p className="ft-h5">
                    <br />
                    <i className="icon icon-articles-empty"></i>
                    <br />
                    <strong>Aucun résultat</strong>
                    <br />
                    Aucune rencontre n’a encore eu lieu.
                  </p>
                </div>
              </Fragment>
            )}
            {resultStatus !== STATUS_LOADING &&
              rencontresFinales.map(rencontre => {
                let updateCompetition = false;
                let updateJournee = false;
                if (rencontre.competitionId !== competitionEnCours) {
                  updateCompetition = true;
                  competitionEnCours = rencontre.competitionId;
                }
                if (rencontre.journeeId !== journeeEnCours) {
                  updateJournee = true;
                  journeeEnCours = rencontre.journeeId;
                }
                return (
                  <Fragment key={rencontre.id}>
                    {updateCompetition && <p className="ft-h6 ft-up">{rencontre.competitionNom}</p>}
                    {updateJournee && (
                      <p className="ft-h6 ft-up ft-center">
                        {rencontre.journeeNom} - {formatFullDateString(rencontre.dateEffective)}
                      </p>
                    )}
                    {this.renderRencontre(rencontre)}
                  </Fragment>
                );
              })}
          </div>
          {slug && rencontresFinales.length > 0 && (
            <div className="card__footer">
              <Link to={`/equipes/${slug}/resultats`} className="link-chevron link-chevron--block">
                <span>Voir tous les résultats de l’équipe</span>
                <i className="icon icon-chevron-right" />
              </Link>
            </div>
          )}
        </div>
      </div>
    );
  };

  changeRankingDropdown = (value: string) => {
    this.setState({ rankingDropdownSelection: value });
  };

  renderRankingRows = (classement: RankingType[]): React$Element<'div'>[] => {
    const filteredClassement = classement.filter(team => !team.nom.includes('EXEMPT'));

    return filteredClassement.map(({ nom, joues, pointTerrain, embleme, position }) => {
      const isMax = nom.length > 15;

      return (
        <div key={`${nom}-${position}`}>
          <span>{position}</span>
          <img src={embleme} alt={`Logo ${nom}`} />
          <p title={nom}>{`${ffrName(nom).slice(0, 15)}${isMax ? '…' : ''}`}</p>
          <span>{pointTerrain}</span>
          <span>{joues}</span>
        </div>
      );
    });
  };

  renderRanking = () => {
    const { ranking } = this.props;
    const { rankingDropdownSelection } = this.state;
    const currentRanking = ranking.filter(
      comp => comp.id === (parseInt(rankingDropdownSelection, 10) || ranking[0].id)
    );
    const hasRanking = currentRanking.length > 0 && currentRanking[0].classement.length > 0;
    const rankingOptions = ranking.map(rank => {
      return { label: rank.nom, value: `${rank.id}` };
    });

    return (
      <div className="col col-md-4 mb-2 mb-lg-4">
        <div className="box box--white card card--rankingSmall ">
          <div className="card__body card__flex-body">
            <h3 className="card__title ft-h3">Classement</h3>
            <div className="card__body__head">
              {hasRanking && (
                <>
                  <DropdownRadioInput
                    id="event_type_dropdown"
                    label={currentRanking[0].nom}
                    options={rankingOptions}
                    inputChanged={this.changeRankingDropdown}
                    radio
                    noBorder
                    maj
                    title
                    isPreThinLabel
                  />

                  <span className="ft-700">Pts</span>
                  <span className="ft-700">J</span>
                </>
              )}
            </div>
            <div className={hasRanking ? 'card__body__rank' : 'card__body__notrank'}>
              {hasRanking && this.renderRankingRows(currentRanking[0].classement)}
              {!hasRanking && (
                <div className="placeholder">
                  <p className="ft-h5">
                    <br />
                    <i className="icon icon-articles-empty"></i>
                    <br />
                    <strong>Aucun classement</strong>
                    <br />
                    Le classement de la compétition n’est pas encore disponible.
                  </p>
                </div>
              )}
            </div>
          </div>
          {/* <div className='card__footer'>
            <Link to={`equipes/${slug}/resultats`} className='link-chevron link-chevron--block'>
              <span>Voir tous les résultats de l’équipe</span>
              <i className='icon icon-chevron-right' />
            </Link>
          </div>
          @TODO: Here we have to take a decision : either we display
          4 rows or 5 rows everywhere to avoid unnecessary calculations*/}
        </div>
      </div>
    );
  };

  renderDownloadCalendar = (title: string, date: Date|string, place: string) => {
    const { clubNom } = this.props;

    this.icsGenerator.addEvent(title, title, place, date, date);

    const download = () => {
      return this.icsGenerator.download();
    };

    return (
      <button
        onClick={handleTagEvent('calendrier', `ajout_${'test'}`, clubNom, download)}
        target="_blank"
        rel="noopener noreferrer"
        className="btn btn--white btn--full"
      >
        <i className="icon icon-calendar is-inline" />
        <span>Ajouter à mon calendrier</span>
      </button>
    );
  };

  renderNextGame = () => {
    const {
      match: {
        params: { slug }
      },
      nextMatches
    } = this.props;
    const now = Object.keys(nextMatches)[0];

    if (now && nextMatches && slug) {
      const {
        id,
        competition: { nom: competitionNom },
        dateEffective,
        dateEffectiveStr,
        localStructure: { nom: localNom, embleme: localEmbleme },
        visiteurStructure: { nom: visiteurNom, embleme: visiteurEmbleme },
        terrain: { nom: nomTerrain, localite },
        etat
      } = nextMatches[now][0];

      const isMaxLocal = localNom.length > 30;
      const isMaxVisit = visiteurNom.length > 30;

      return (
        <div className="col col-md-4 mb-2 col-lg-4">
          <div className="box box--white card card--nextGameWhite">
            <div className="card__body card__flex-body">
              <h3 className="card__title ft-h3">{etat === 'En direct' ? 'Match en cours' : 'Prochain match'}</h3>
              <div className="label">{etat === 'En direct' ? 'En cours' : 'À venir'}</div>
              <Link
                to={`/equipes/${slug}/match/${id}`}
                className="flex1"
                title={`Voir les informations du match ${localNom}-${visiteurNom}`}
              >
                <p className="ft-h6 ft-up">{competitionNom}</p>
                <p className="ft-h6 ft-up mb-3">{formatFullDateString(getDateFromString(dateEffective))}</p>
                <p className="ft-h3 ft-400 mb-3">
                  <img src={localEmbleme} alt={`Logo ${localNom}`} width="40" height="40" />
                  <span title={localNom}>{`${ffrName(localNom).slice(0, 30)}${isMaxLocal ? '...' : ''}`}</span>
                </p>
                <p className="ft-h3 ft-400 mb-4 mb-lg-3">
                  <img src={visiteurEmbleme} alt={`Logo ${visiteurNom}`} width="40" height="40" />
                  <span title={visiteurNom}>{`${ffrName(visiteurNom).slice(0, 30)}${isMaxVisit ? '...' : ''}`}</span>
                </p>
                <p className="mb-2">
                  <i className="icon icon-place is-inline" />
                  <span>
                    {nomTerrain}, {localite}
                  </span>
                </p>
              </Link>
              {etat !== 'En direct' &&
                this.renderDownloadCalendar(`${localNom}-${visiteurNom}`, dateEffectiveStr, `${nomTerrain}, ${localite}`)}
            </div>
            {slug && (
              <div className="card__footer">
                <Link to={`/equipes/${slug}/calendrier`} className="link-chevron ">
                  <span>Consulter l&apos;agenda</span>
                  <i className="icon icon-chevron-right" />
                </Link>
              </div>
            )}
          </div>
        </div>
      );
    } else {
      return (
        <div className="col col-md-4 mb-2 col-lg-4">
          <div className="box box--white card card--nextGameWhite">
            <div className="card__body card__flex-body">
              <h3 className="card__title ft-h3">Prochain match</h3>
              <div className="placeholder">
                <p className="ft-h5" style={{ color: '#CCC' }}>
                  <br />
                  <i className="icon icon-articles-empty"></i>
                  <br />
                  <strong>Aucun match</strong>
                  <br />
                  Le prochain match de la compétition n’est pas encore disponible.
                </p>
              </div>
            </div>
          </div>
        </div>
      );
    }
  };

  render() {
    return (
      <div className="row">
        <div className="col">
          <h3 className="ft-h2 mb-3 mb-lg-4">Résultats &amp; Classement</h3>
        </div>
        {this.renderLastResults()}
        {this.renderRanking()}
        {this.renderNextGame()}
      </div>
    );
  }
}
